import { Block, Copy03 as CopyIcon, LinkExternal02 as LinkIcon, ParagraphSmall, useStyletron, } from "@mezo-org/mezo-clay";
import React, { useCallback, useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";
import { usePassportContext } from "../../hooks/usePassportContext";
import { getAddressExplorerUrl, trimAddress } from "../../utils/address";
import { getCryptoAsset } from "../../utils/cryptoAssets";
// TODO: Add visual feedback on copy
export default function AccountAddress(props) {
    const { address, type } = props;
    const { environment } = usePassportContext();
    const blockExplorerUrl = getAddressExplorerUrl(address, type, environment === "testnet");
    const trimmedAddress = trimAddress(address);
    const { icon: accountIcon } = getCryptoAsset(type === "bitcoin" ? "btc" : "eth");
    const [, theme] = useStyletron();
    const [, copy] = useCopyToClipboard();
    const [isCopiedMessageVisible, setIsCopiedMessageVisible] = useState(false);
    const handleCopyAddress = useCallback(() => {
        copy(address);
        setIsCopiedMessageVisible(true);
        setTimeout(() => {
            setIsCopiedMessageVisible(false);
        }, 2000);
    }, [copy, address]);
    return (React.createElement(Block, { as: "button", onClick: handleCopyAddress, display: "flex", alignItems: "center", backgroundColor: "transparent", padding: `${theme.sizing.scale600} ${theme.sizing.scale500}`, overrides: {
            Block: {
                style: {
                    borderWidth: 0,
                    cursor: "pointer",
                    ":hover": {
                        backgroundColor: theme.colors.backgroundTertiary,
                    },
                },
            },
        } },
        React.createElement(Block, { as: accountIcon, size: theme.sizing.scale600 }),
        isCopiedMessageVisible ? (React.createElement(ParagraphSmall, { margin: 0, marginLeft: theme.sizing.scale300, color: theme.colors.gray800 }, "Copied address to clipboard")) : (React.createElement(Block, { as: "a", marginLeft: theme.sizing.scale300, href: blockExplorerUrl, target: "_blank", overrides: {
                Block: {
                    style: {
                        color: "inherit",
                        textDecoration: "none",
                        ":hover": {
                            textDecoration: "underline",
                        },
                    },
                },
            } },
            React.createElement(ParagraphSmall, { display: "flex", alignItems: "center", margin: 0, color: theme.colors.gray800 },
                trimmedAddress,
                React.createElement(LinkIcon, { display: "inline", size: theme.sizing.scale550, overrides: {
                        Svg: {
                            style: {
                                stroke: "currentColor",
                                marginLeft: theme.sizing.scale200,
                            },
                        },
                    } })))),
        React.createElement(CopyIcon, { size: theme.sizing.scale550, overrides: {
                Svg: {
                    style: {
                        marginLeft: "auto",
                        stroke: "currentColor",
                    },
                },
            } })));
}
//# sourceMappingURL=AccountAddress.js.map